// extracted by mini-css-extract-plugin
export default {"content":"styles_content__c-caU","text":"styles_text__chGlO"};